export default "__VITE_ASSET__DC29ukv9__"